import { Box, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AnuncioService from "../../services/AnuncioService";
import AccountService from "../../services/AccountService";
import AreaService from "../../services/AreaService";
import AudienciaService from "../../services/AudienciaService";
import UnidadService from "../../services/UnidadService";
import RevisorService from "../../services/RevisorService";

export const TestPage: React.FC<{}> = () => {
    const [loading, setLoading] = useState(true);
    //region function
    const fetchAnunciosFree = async () => {
        setLoading(true)
        try {
            // const response = await AccountService.InfoGestor();
            // const data = response;
            // if (response) {
            //     console.log(data)
            // }
            // const response2 = await AnuncioService.GetMisAnuncios();
            // const data2 = response2;
            // if (response2) {
            //     console.log(data2)
            // }
            // const response3 = await AnuncioService.GetMiAnuncio(2661);
            // const data3 = response3;
            // if (response3) {
            //     console.log(data3)
            // }
            // const response4 = await AreaService.GetAreas();
            // const data4 = response4;
            // if (response4) {
            //     console.log(data4)
            // }
            // const response5 = await CategoriasService.GetCategorias();
            // const data5 = response5;
            // if (response5) {
            //     console.log(data5)
            // }
            const response6 = await AreaService.GetAreasGestorbyUsername('fsmoreno');
            const data6 = response6;
            if (response6) {
                console.log(data6)
            }
            const response7 = await AudienciaService.GetAudiencias();
            const data7 = response7;
            if (response7) {
                console.log(data7)
            }
            const response8 = await UnidadService.GetUnidades();
            const data8 = response8;
            if (response8) {
                console.log(data8)
            }
            const response9 = await AccountService.GetAccountsPaginate();
            const data9 = response9;
            if (response9) {
                console.log(data9)
            }
            const response10 = await AnuncioService.GetMisAnunciosPaginateSearch('T','s')
            const data10 = response10;
            if (response10) {
                console.log(data10)
            }
            const response11 = await RevisorService.GetAnunciosParaRevisor('P');
            const data11 = response11;
            if (response11) {
                console.log(data11)
            }
            const response12 = await RevisorService.GetAnunciosParaRevisorSearch('P','ru');
            const data12 = response12;
            if (response12) {
                console.log(data12)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    //endregion
    //region useEffect
    useEffect(() => {
        fetchAnunciosFree();
    }, []);
    //endregion
    return (
        <Container maxWidth="lg" style={{ marginTop: 6, padding: '20px', textAlign: 'center' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom>
                    Api Tester
                </Typography>
            </Box>
            {loading ? 'cargando' : ''}
            <Box sx={{ display: 'flex' }}>
                {/* Contenido principal */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                    }}
                >
                    Nada que ver
                </Box>
            </Box>
        </Container>
    )
}